import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) { setLoading(false); return; }
    try {
      const me = await api.get('/auth/me');
      setUser(me);
    } catch {
      localStorage.clear();
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadUser(); }, [loadUser]);

  const login = async (username, password) => {
    const data = await api.post('/auth/login', { username, password });
    localStorage.setItem('accessToken',  data.accessToken);
    localStorage.setItem('refreshToken', data.refreshToken);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    try { await api.post('/auth/logout', { refreshToken }); } catch {}
    localStorage.clear();
    setUser(null);
  };

  const isAdmin      = user?.role === 'admin';
  const isSM         = user?.role === 'sales_manager';
  const isAreaSup    = user?.role === 'area_supervisor';
  const isSupervisor = user?.role === 'supervisor';
  const isSalesman   = user?.role === 'salesman';
  const canManage    = isAdmin || isSM;
  const canSupervise = isAdmin || isSM || isAreaSup || isSupervisor;

  return (
    <AuthContext.Provider value={{
      user, loading, login, logout,
      isAdmin, isSM, isAreaSup, isSupervisor, isSalesman,
      canManage, canSupervise,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
